import { z } from 'zod';
import { appointmentTypeZodEnum } from '../../enum';
import { userIdDto } from '../user';

export const appointment = z
  .object({
    id: z.string(),
    organizerId: z.string(),
    userId: userIdDto,
    teamId: z.number(),
    eventTypeId: z.number(),
    type: appointmentTypeZodEnum(),
    location: z.string(),
    cancellationReason: z.string().nullable(),
    startTime: z.coerce.date(),
    endTime: z.coerce.date(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
  })
  .nullable();

export type Appointment = z.infer<typeof appointment>;

export const appointmentResDto = z.object({
  latestAppointment: appointment,
});

export type AppointmentResDto = z.infer<typeof appointmentResDto>;
